import { render, staticRenderFns } from "./_paymentMethods.vue?vue&type=template&id=4e4a1ec6"
import script from "./_paymentMethods.vue?vue&type=script&lang=js"
export * from "./_paymentMethods.vue?vue&type=script&lang=js"
import style0 from "./_paymentMethods.vue?vue&type=style&index=0&id=4e4a1ec6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports